// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"4120d999bd4e97427a11","655":"0169ef9e041831fb8d6f"}[chunkId] + ".js";
};